<div class="displayTable">
  <div class="displayTableCell">


    <h1>bloom </h1>
    <div class="authBlock">

      <div class="container">
        <div class="signup">
          <h3>Sign Up</h3>
          <div class="formGroup">
            <input type="displayName" class="formControl" placeholder="Username" #displayName required>
          </div>

          <div class="formGroup">
            <input type="email" class="formControl" placeholder="Email Address" #userEmail required>
          </div>

          <div class="formGroup">
            <input type="password" class="formControl" placeholder="Password" #userPwd required>
          </div>

          <div class="formGroup">
            <input type="button" class="btn btnPrimary" value="SIGN UP"
              (click)="authService.SignUp(userEmail.value, userPwd.value, displayName.value)">
            <!--  -->
          </div>

          <div class="formGroup">
            <span class="or"><span class="orInner">Or</span></span>
          </div>

          <div class="redirectToLogin">
            <span>Already have an account? <br><span class="redirect" routerLink="/sign-in"><b>Log In</b></span></span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>